import { render, staticRenderFns } from "./identification.vue?vue&type=template&id=2c9a8cd9&scoped=true"
import script from "./identification.vue?vue&type=script&lang=js"
export * from "./identification.vue?vue&type=script&lang=js"
import style0 from "./identification.vue?vue&type=style&index=0&id=2c9a8cd9&prod&scoped=true&lang=css"
import style1 from "./identification.vue?vue&type=style&index=1&id=2c9a8cd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a8cd9",
  null
  
)

export default component.exports